import { render, staticRenderFns } from "./FRM_TpoUnidad.vue?vue&type=template&id=d85514c6&"
import script from "./FRM_TpoUnidad.vue?vue&type=script&lang=js&"
export * from "./FRM_TpoUnidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports